<template>
    <li class="add-button" @click="$emit('show-popup', false)">
        Add a PassCard
        <svg stroke="currentColor" fill="currentColor" stroke-width="0" t="1569683928793" viewBox="0 0 1024 1024" version="1.1" pId="15091" height="3em" width="3em" xmlns="http://www.w3.org/2000/svg"><defs></defs><path d="M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H212V212h200v200zM864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16z m-52 268H612V212h200v200zM864 544H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z m-52 268H612V612h200v200zM424 712H296V584c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v128H104c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h128v128c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V776h128c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z" pId="15092"></path></svg>
    </li>
</template>

<script>
export default {
    props: {
        passCardItem: Object
    },
    emits: ['show-popup']
}
</script>